import React, { Component } from "react";

import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import Breadcrumb from "../../../../components/Breadcrumb";
import Form from "../../../../components/Forms/Form";
import { required } from "../../../../components/Forms/validators";
import Loading from "../../../../components/Loading";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";

class TranslationCreate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      edit: false,
      // user: {},
      loading: false,
      fields: []
    };
    this.enviar = this.enviar.bind(this);
    this.atualizar = this.atualizar.bind(this);
    this.error = this.error.bind(this);
    this.fieldsMount = this.fieldsMount.bind(this);
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Fail", response);
    }
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);

    const idUser = this.props.match.params.id;
    if (idUser) {
      this.setState(
        () => ({
          loading: true,
          id: idUser
        }),
        () => {
          axios
            .get(`${URL.api}configuration/translation/singleView/${idUser}`, {
              headers: { authorization: `Bearer ${this.props.user.token}` }
            })
            .then(resp => {
              this.setState(
                () => ({
                  translation: resp.data.data
                }),
                () => {
                  this.setState(() => ({
                    edit: true
                  }));
                },
                error => {
                  this.error(error.response.statusText);
                }
              );
            });
        }
      );
    }

    axios
      .get(`${URL.api}configuration/language/list`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        let fieldsArray = this.fieldsMount(resp.data.data);
        this.setState(
          () => ({
            fields: fieldsArray
          }),
          () => {
            this.setState(() => ({
              loading: false
            }));
          },
          error => {
            this.error(error.response.statusText);
          }
        );
      });
  }

  fieldsMount(languages) {
    let fields = [];
    for (let index = 0; index < languages.length; index++) {
      let obj = {
        name: languages[index].id,
        label: languages[index].name,
        type: "text",
        required: true,
        icon: "fa fa-text-width",
        value: "",
        validate: [required]
      };
      fields[index] = obj;
    }
    return fields;
  }

  enviar(value) {
    let obj = {
      language_id: value.language_id,
      field: value.field,
      text: value.text
    };
    axios
      .post(`${URL.api}configuration/translation/insert`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        toastr.warning(
          "Tradução",
          "Após o cadastro de uma lingua é necessário o cadastro de suas traduções"
        );
        this.props.history.push("/translation/list");
      });
  }

  atualizar(value) {
    let obj = {
      language_id: value.language_id,
      field: value.field,
      text: value.text,
      id: this.state.id
    };
    axios
      .post(
        `${URL.api}configuration/translation/update/${this.state.id}`,
        obj,
        { headers: { authorization: `Bearer ${this.props.user.token}` } }
      )
      .then(resp => {
        this.props.history.push("/translation/list");
      });
  }

  render() {
    let buttons = [
      {
        name: "Enviar",
        submit: false,
        icon: "fa fa-cloud",
        iconSide: "left",
        custom: this.enviar,
        color: "primary"
      }
    ];

    return (
      <React.Fragment>
        <Breadcrumb
          current={this.props.currentRoute}
          items={[{ path: "/translation/list", to: "/translation/list" }]}
        />
        {this.state.loading ? (
          <Loading top="45" left="50" />
        ) : (
          <div>
            <Form
              avatar
              fields={this.state.fields}
              back
              history={this.props.history}
              buttons={buttons}
              onSubmit={this.state.edit ? this.atualizar : this.enviar}
              initialValues={this.state.translation}
              edit={this.state.edit}
            />
          </div>
        )}
        <ProtectedRoute routeId={this.props.currentRoute} />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(TranslationCreate);
